import { Component, OnInit, ViewChild, AfterViewInit, ElementRef , HostListener, ɵConsole } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { tap, catchError, finalize, debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { DataSource } from '@angular/cdk/table';
import { BehaviorSubject, Observable, of, fromEvent } from 'rxjs';
import { CollectionViewer } from '@angular/cdk/collections';
import { projectConstants } from '../../../shared/constants/project-constants';
import { PaginationService } from 'src/app/services/pagination.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonfilterService } from 'src/app/services/commonfilter.service';
import { UnverifiedAccountService } from 'src/app/services/unverified-account.service';
import { UnverifiedViewComponent } from '../unverified-view/unverified-view.component';
import { MatPaginator } from '@angular/material/paginator';
@Component({
  selector: 'app-unverified-account-list',
  templateUrl: './unverified-account-list.component.html',
  styleUrls: ['./unverified-account-list.component.css']
})
export class UnverifiedAccountListComponent implements OnInit, AfterViewInit {
  dataSource = new UnverifiedAccountDataSource(this.unverifiedaccountService);
  tableFilters = '';
  displayedColumns = ['loginId','createdDate' , 'otpPurpose', 'sharedkey','sector','verified', 'firstName', 'phone' , 'details'];
  @ViewChild(MatPaginator, {static: false}) paginator: MatPaginator;
  @ViewChild('go', {static: false}) go: ElementRef;
  selectedRowIndex = -1;
  showToolBar = false;
  collapsed;
  collapsedlcFilter;
  unverifyCount: any;
  Config: any = {};
  userTypes: any = [];
  screenHeight;
  screenWidth;
  salesChannelss;
  paymentDetais;
  showsaleschannel;
  small_device_display = false;
  salesfilter;
  accountTypes: any = [];
  salesChannelfilter;
  consumerCount: number;
  user: any;
  type: any;
  UnverifiedAccount: any;
  otpPurposes: any = [];
  unverify_values: any;
  unverifyaccounts: any;
  values: any;
  payloadvalue: any;
  payvalue: any;
  unvrifynew: any;
  otp_purpose = projectConstants.OTP_PURPOSES;
  domain = projectConstants.DOMAIN;
  verifiedList: any = [
    { name: "unverified", displayName: "Unverified"},
    { name: "verified", displayName: "Verified"},
    { name: "locked", displayName: "Locked"},
    { name: "expired", displayName: "Expired"}
  ];
  constructor(
    private pagination: PaginationService,
    private unverifiedaccountService: UnverifiedAccountService,
    private commonFilter: CommonfilterService,
    private route: ActivatedRoute,
    private router: Router,
    private commonfilterService: CommonfilterService,
    private activatedRoute: ActivatedRoute,
    private dialog: MatDialog ) {
      this.commonfilterService.getConfigData()
      .subscribe(res => {
        this.Config = res;
        // console.log(this.Config)
        this.otpPurposes = this.Config.otpPurposeDetails;
      });
      this.onResize();
    }

  ngOnInit() {
    this.dataSource.loadUnverifyAccount(this.tableFilters, 'false', 0, 100);
   
    this.getTotalCountByFilters(this.tableFilters);
  }
  @HostListener('window:resize', ['$event'])
  onResize() {
    this.screenHeight = window.innerHeight;
    this.screenWidth = window.innerWidth;
    if (this.screenWidth <= projectConstants.SMALL_DEVICE_BOUNDARY) {
      this.small_device_display = true;
    } else {
      this.small_device_display = false;
    }
  }
  getTotalCountByFilters(filters) {
    this.unverifiedaccountService.getTotalFilterCount(filters)
      .subscribe(res => {
        this.unverifyCount = res;
        // this.paginator.pageIndex = 0;
      });
  }
  ngAfterViewInit() {
    this.paginator.page
    .pipe(
        tap(() => this.loadUnverifyPage())
    )
    .subscribe();

    fromEvent(this.go.nativeElement, 'click')
    .pipe(
        debounceTime(150),
        distinctUntilChanged(),
        tap(() => {
          this.tableFilters = this.commonFilter.createfilterParams('UnverifiedAccount');
            this.getTotalCountByFilters(this.tableFilters);
            this.paginator.pageIndex = 0;
            this.loadUnverifyPage();


        })
    )
    .subscribe();
  }
  getview(UnverifiedAccount){
    this.selectedRowIndex = UnverifiedAccount;
    // console.log(this.selectedRowIndex)
const dialogRef = this.dialog.open(UnverifiedViewComponent, {
    width: '800px',
    height: '300px',
    data: this.selectedRowIndex 
  });

  dialogRef.afterClosed().subscribe(result => {
    this.selectedRowIndex = -1;
  });
  }
  
  loadUnverifyPage() {
    // const count = 10;
    const count = (this.paginator.pageSize * (this.paginator.pageIndex + 1)) - 100;
    this.dataSource.loadUnverifyAccount(
      this.tableFilters, 'false', count,
      this.paginator.pageSize
   );

  }
  onRowClicked(UnverifiedAccount) {
    this.selectedRowIndex = UnverifiedAccount.loginId;
    this.showToolBar = !this.showToolBar;
  }
  getFirstName_Frmpayload(UnverifiedAccount){
    for (let i in UnverifiedAccount) {
        this.unverifyaccounts = UnverifiedAccount[i];
        if(i === 'payload'){
          this.unvrifynew = JSON.parse(this.unverifyaccounts)
          for (let j in this.unvrifynew){
            this.payvalue = this.unvrifynew[j];
            if( j === 'userProfile'){
              this.values = this.payvalue.firstName;
            return this.values 
            }
          }
         
        }     
    }
  }
  getverified_Frmpayload(UnverifiedAccount){
    for (let i in UnverifiedAccount) {
        this.unverifyaccounts = UnverifiedAccount[i];
        // console.log(this.unverifyaccounts)
        if(i === 'verified'){
              return this.unverifyaccounts === true ? 'Yes' : 'No' ;
        }     
    }
  }
  getLastName_Frmpayload(UnverifiedAccount){
    for (let i in UnverifiedAccount) {
        this.unverifyaccounts = UnverifiedAccount[i];
        if(i === 'payload'){
          this.unvrifynew = JSON.parse(this.unverifyaccounts)
          for (let j in this.unvrifynew){
            this.payvalue = this.unvrifynew[j];
            if( j === 'userProfile'){
              this.values = this.payvalue.lastName;
            return this.values 
            }
          }
         
        }     
    }
  }
  getphone_Frmpayload(UnverifiedAccount){
    for (let i in UnverifiedAccount) {
        this.unverifyaccounts = UnverifiedAccount[i];
        if(i === 'payload'){
          this.unvrifynew = JSON.parse(this.unverifyaccounts)
          for (let j in this.unvrifynew){
            this.payvalue = this.unvrifynew[j];
            if( j === 'userProfile'){
              this.values = this.payvalue.primaryMobileNo;
            return this.values 
            }
          }
         
        }     
    }
  }
  getcountryCode_Frmpayload(UnverifiedAccount){
    for (let i in UnverifiedAccount) {
        this.unverifyaccounts = UnverifiedAccount[i];
        if(i === 'payload'){
          this.unvrifynew = JSON.parse(this.unverifyaccounts)
          for (let j in this.unvrifynew){
            this.payvalue = this.unvrifynew[j];
            if( j === 'userProfile'){
              this.values = this.payvalue.countryCode;
            return this.values 
            }
          }
         
        }     
    }
  }
  
  getsector_Frmpayload(UnverifiedAccount){
    for (let i in UnverifiedAccount) {
        this.unverifyaccounts = UnverifiedAccount[i];
        if(i === 'payload'){
          this.unvrifynew = JSON.parse(this.unverifyaccounts)
         return this.unvrifynew.sector
         
        }     
    }
  }
  
  
}
export class UnverifiedAccountDataSource implements DataSource<any> {
  unverify_values: any;
  unverifyaccounts: any;
  values: any;
  UnverifiedAccount: any;
  callvalue: any;
  payloadvalue: any;
  firstname: any;
  first: string;
  value: any;

  constructor(private unverifiedaccountService: UnverifiedAccountService) {

  }
  public loadingSubject = new BehaviorSubject<boolean>(false);

  public loading$ = this.loadingSubject.asObservable();

  private salesChannelSubject = new BehaviorSubject<any>([]);

  connect(collectionViewer: CollectionViewer): Observable<any[]> {
    return this.salesChannelSubject.asObservable();
  }
  disconnect(collectionViewer: CollectionViewer): void {
    this.salesChannelSubject.complete();
    this.loadingSubject.complete();
  }
  loadUnverifyAccount(filter,
    sortDirection, tcount, pageSize) {
    this.loadingSubject.next(true);
    this.unverifiedaccountService.getUnverifyAccounts(filter, sortDirection,
      tcount, pageSize).pipe(
        catchError(() => of([])),
        finalize(() => this.loadingSubject.next(false))
      )
      .subscribe(
        UnverifiedAccount => {    
          this.salesChannelSubject.next(UnverifiedAccount);
        }
      );
  }
 
}
